<template>
  <div class="invoice-details-section">
    <div class="documents-section">
      <template v-if="data && data.length > 0">
        <div class="section">
          <b-row>
            <b-col :lg="12" v-for="document in data" :key="document.id">
              <div
                class="d-flex justify-content-between align-items-center document-container mb-3 mb-md-4"
              >
                <div class="icon">
                  <div class="svg">
                    <b-icon-file-earmark-text-fill />
                  </div>
                </div>
                <div class="content text-left w-100">
                  <p class="upload-placeholder-title">
                    {{ document.file_identifier.slice(0, 30)
                    }}{{ document.file_identifier.length > 29 ? '...' : '' }} -
                    {{ getDocumentTag(document) }}
                  </p>
                  <a
                    :href="getDownloadUrl(document)"
                    target="_blank"
                    class="upload-desc"
                  >
                    {{ $t('invoices.single.documents.date') }}
                    {{
                      (document.updated_at || 'N/A') | moment('DD MMMM, YYYY')
                    }}
                  </a>
                </div>
                <div class="icon">
                  <div class="svg">
                    <a :href="getDownloadUrl(document)" target="_blank"
                      ><b-icon-download
                    /></a>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  methods: {
    getDocumentTag(document) {
      if (
        this.$store.state.account.country === 'Mexico' &&
        document.tags_value &&
        document.tags_value.includes('Shipping Bill')
      ) {
        return 'Pedimento'
      }
      return document.tags_value
    },
    getDownloadUrl(document) {
      return `${process.env.VUE_APP_DRIP_WEB_HOST}/documents/${document.id}/auth/${document.auth_token}`
    }
  }
}
</script>
